import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ListItem from './ListItem';
// import radium from 'radium';
// import Relay from 'react-relay/classic';

class ListFamily extends Component {
  static styles = {};

  static contextTypes = {
    dispatch: PropTypes.func
  };

  renderItems = (editable, dispatch, variant) => (item, i) => (
    <ListItem
      key={i}
      index={i}
      item={item}
      editable={editable}
      dispatch={dispatch}
      variant={variant}
      addNewListItem={this.addNewListItem}
      removeListItem={this.removeListItem}
    />
  );

  addNewListItem = (index, newItem) => {
    const {
      lesson: { _id, items }
    } = this.props;
    items.splice(index, 0, newItem);
    const newItems = items.map((item, i) => {
      item.number = i + 1;
      return item;
    });
    this.context.dispatch(
      'UPDATE_ITEM_DATA',
      {
        _id,
        items: newItems
      },
      null,
      true
    );
  };

  removeListItem = (index, itemId) => {
    const {
      lesson: { _id, items }
    } = this.props;
    items.splice(index, 1);
    const newItems = items.map((item, i) => {
      item.number = i + 1;
      return item;
    });

    this.context.dispatch(
      'UPDATE_ITEM_DATA',
      {
        _id,
        items: newItems
      },
      null,
      true
    );
  };

  render() {
    const {
      lesson: { variant, items }
    } = this.props;
    const { editable, dispatch } = this.props;

    return (
      <div className="ListFamilyContainer">
        <div>
          <div className={'block-list block-list--' + variant}>
            <div className="">
              <div className="">
                <div className="">
                  <ul className={'block-list__list block-list-type-' + variant}>
                    {items.map(this.renderItems(editable, dispatch, variant))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListFamily;
